import {
  ADD_DOCTOR_FAILURE,
  ADD_DOCTOR_REQUEST,
  ADD_DOCTOR_SUCCESS,
  DELETE_DOCTOR_FAILURE,
  DELETE_DOCTOR_REQUEST,
  DELETE_DOCTOR_SUCCESS,
  FETCH_DOCTOR_FAILURE,
  FETCH_DOCTOR_REQUEST,
  FETCH_DOCTOR_SUCCESS,
  FETCH_LIST_DOCTORS_FAILURE,
  FETCH_LIST_DOCTORS_REQUEST,
  FETCH_LIST_DOCTORS_SUCCESS,
  HISTORY_DOCTORS_FAILURE,
  HISTORY_DOCTORS_REQUEST,
  HISTORY_DOCTORS_SUCCESS,
  RESET_CURRENT_DOCTOR,
  UPDATE_DOCTOR_FAILURE,
  UPDATE_DOCTOR_REQUEST,
  UPDATE_DOCTOR_SUCCESS,
} from "./doctorType";

export const fetchDoctors = (pageNo) => ({
  type: FETCH_LIST_DOCTORS_REQUEST,
  payload: pageNo,
});

export const fetchDoctorsSuccess = (doctors) => ({
  type: FETCH_LIST_DOCTORS_SUCCESS,
  payload: { doctors },
});

export const fetchDoctorsFailure = (error) => ({
  type: FETCH_LIST_DOCTORS_FAILURE,
  payload: { error },
});

export const fetchHistoryDoctors = (id) => ({
  type: HISTORY_DOCTORS_REQUEST,
  payload: id,
});

export const fetchHistoryDoctorsSuccess = (doctors) => ({
  type: HISTORY_DOCTORS_SUCCESS,
  payload: { doctors },
});

export const fetchHistoryDoctorsFailure = (error) => ({
  type: HISTORY_DOCTORS_FAILURE,
  payload: { error },
});

// View single doctor
export const fetchDoctor = (doctorId) => ({
  type: FETCH_DOCTOR_REQUEST,
  payload: { doctorId },
});

export const fetchDoctorSuccess = (doctor) => ({
  type: FETCH_DOCTOR_SUCCESS,
  payload: { doctor },
});

export const fetchDoctorFailure = (error) => ({
  type: FETCH_DOCTOR_FAILURE,
  payload: { error },
});

// Add doctor
export const addDoctor = (doctorData) => ({
  type: ADD_DOCTOR_REQUEST,
  payload: { doctorData },
});

export const addDoctorSuccess = (doctor) => ({
  type: ADD_DOCTOR_SUCCESS,
  payload: { doctor },
});

export const addDoctorFailure = (error) => ({
  type: ADD_DOCTOR_FAILURE,
  payload: { error },
});

// Edit doctor
export const updateDoctor = (doctorId, doctorData) => ({
  type: UPDATE_DOCTOR_REQUEST,
  payload: { doctorId, doctorData },
});

export const updateDoctorSuccess = (doctor) => ({
  type: UPDATE_DOCTOR_SUCCESS,
  payload: { doctor },
});

export const updateDoctorFailure = (error) => ({
  type: UPDATE_DOCTOR_FAILURE,
  payload: { error },
});

// Delete doctor
export const deleteDoctor = (doctorId) => ({
  type: DELETE_DOCTOR_REQUEST,
  payload: { doctorId },
});

export const deleteDoctorSuccess = (doctorId) => ({
  type: DELETE_DOCTOR_SUCCESS,
  payload: { doctorId },
});

export const deleteDoctorFailure = (error) => ({
  type: DELETE_DOCTOR_FAILURE,
  payload: { error },
});

// Reset current doctor
export const resetCurrentDoctor = () => ({
  type: RESET_CURRENT_DOCTOR,
});